import { QueryKey, UseQueryResult, useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { GeneralStats } from '../types'
import { spark2ApiUrl } from '@/config/consts'
import { normalizedNumberSchema } from '@/domain/common/validation'

export type UseSpkStakingGeneralStatsResult = UseQueryResult<GeneralStats>

export function useSpkStakingGeneralStats(): UseSpkStakingGeneralStatsResult {
  return useQuery({
    queryKey: spkStakingGeneralStatsQueryKey(),
    queryFn: spkStakingGeneralStatsQueryFunction,
  })
}

export function spkStakingGeneralStatsQueryKey(): QueryKey {
  return ['spk-staking', 'generalStats']
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export async function spkStakingGeneralStatsQueryFunction() {
  const response = await fetch(`${spark2ApiUrl}/spk-staking/stats/`)
  if (!response.ok) {
    throw new Error('Error fetching SPK staking stats')
  }

  const result = await response.json()
  const parsedResult = spkStakingGeneralStatsResponseSchema.parse(result)

  return {
    totalStaked: parsedResult.totalStaked,
    stakers: parsedResult.stakers,
  }
}

export const spkStakingGeneralStatsResponseSchema = z
  .object({
    total_staked: normalizedNumberSchema,
    number_of_wallets: z.number(),
  })
  .transform((o) => ({
    totalStaked: o.total_staked,
    stakers: o.number_of_wallets,
  }))
